import React from 'react';
import { CButton, CSpinner } from '@coreui/react';
import classNames from 'classnames';
import CIcon from '@coreui/icons-react';

interface IButton {
  title: string;
  loading?: boolean;
  className?: string;
  [key: string]: any;
  iconName?: string;
}

export const Button: React.FunctionComponent<IButton> = ({
  title,
  loading = false,
  disabled,
  className = '',
  iconName,
  ...props
}) => {
  const classes = classNames({
    [className]: true,
  }, 'button');

  return (
    <CButton {...props} className={classes} disabled={loading || disabled}>
      <span className="button-title">{title}</span>
      {loading ? <CSpinner color="white" className="button-spinner" size="sm" /> : ''}
      {iconName ? <CIcon className="button-icon" name={iconName} /> : ''}
    </CButton>
  );
};
